import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Stack, Tooltip } from "@mui/material";
import { iconSize, quickColor } from "../App/GridRenderers";
import { faForwardFast } from "@fortawesome/free-solid-svg-icons";


const QuickStartIcon = ({ mt = 0, onClick }) => {
    return (
        <div>
            <Stack sx={{ px: 2, pt: 2, mt: mt }}>
                <Tooltip title="Quick Client/Account add"
                    enterDelay={1000}>
                    <FontAwesomeIcon
                        icon={faForwardFast}
                        color={quickColor}
                        size={iconSize}
                        onClick={onClick}
                    />
                </Tooltip>

            </Stack>
        </div >
    );
};

export const QuickUpdateIcon = ({ mt = 0, onClick }) => {
    return (
        <div>
            <Stack sx={{ px: 2, pt: 2, mt: mt }}>
                <Tooltip title="Quick Update"
                    enterDelay={1000}>
                    <FontAwesomeIcon
                        icon={faForwardFast}
                        color={quickColor}
                        size={iconSize}
                        onClick={onClick}
                    />
                </Tooltip>
            </Stack>
        </div >
    );
};

export default QuickStartIcon;